import React from 'react'
import { cn } from '../../lib/utils'

interface ChallengeCardProps {
  text: string
  selected: boolean
  onClick: () => void
}

export const ChallengeCard: React.FC<ChallengeCardProps> = ({ text, selected, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'border-2 rounded-lg p-4 text-center cursor-pointer transition-all duration-200',
        selected
          ? 'border-[#9B775D]'
          : 'border-gray-300 hover:border-[#145F6B]'
      )}
      style={selected ? { backgroundColor: 'rgb(246, 241, 237)' } : { backgroundColor: 'white' }}
    >
      <span className="text-base" style={{ color: 'rgb(15,15,15)' }}>
        {text}
      </span>
    </div>
  )
}

